import { Component } from 'react'
import styled from '@emotion/styled'
import { Box } from 'stylewhere/components'
import { T, __ } from 'stylewhere/i18n'
import { getProductCode, buildGridTemplate } from 'stylewhere/shared/utils'
import { OrderUserCountersRow, OrderUserColumn } from 'stylewhere/api'
import { get as _get } from 'lodash'

interface Props {
  row: OrderUserCountersRow
  rowIndex: number
  rowsCount: number
  columns: OrderUserColumn[]
  orderIndex: number
}

export class EncodingUserCountersOrderRowData extends Component<Props> {
  getLabel = (product, key): string => {
    let label = '---'
    if (product?.[key]) {
      label =
        product[key]?.value && product[key].value != null
          ? product[key]?.value
          : product[key]?.description
            ? product[key]?.description
            : '---'
    }
    return label
  }

  getValue = (row, column) => {
    if (column.isProductCode) {
      return getProductCode(row.product)
    } else if (column.isProductAttribute) {
      return this.getLabel(row.product, column.field)
    } else if (column.progress) {
      return row.totalEncodings + '/' + row.totalQuantity
    } else if (column.field) {
      return _get(row, column.field) ?? '---'
    }
    return '---'
  }

  render() {
    const { row, rowIndex, columns, rowsCount, orderIndex } = this.props
    const gridStyle = {
      display: 'grid',
      gridTemplateColumns: buildGridTemplate(columns)
    }
    return (
      <ItemRow row ml={0} mr={0} last={rowIndex === rowsCount - 1} style={gridStyle}>
        {columns.map((col, i) => {
          return (
            <ItemColumn
              key={'row-col-' + orderIndex + '-' + rowIndex + '-' + i}
              pt={10}
              pb={10}
              center={col.center ?? false}
              last={i === columns.length - 1}
            >
              {this.getValue(row, col)}
            </ItemColumn>
          )
        })}
      </ItemRow>
    )
  }
}

const ItemRow = styled(Box)<{ last?: boolean }>`
  border: 0px;
`

const ItemColumn = styled(Box)<{ last?: boolean }>`
  padding-right: ${(props) => (props.last ? '0px' : '15px')};
  color: #454545;
  font-weight: 300;
  font-size: 20px;
  line-height: 24px;
  justify-content: center;
`
